import Persistable from "../../../storage/persistable";
import PlayerContext from "./player-context";

export default class TeamContext extends Persistable {
    constructor(teamId) {
        super();

        this.teamId = teamId;
        this.playerContexts = [];
    }

    getPlayerContext(playerId) {
        if (!this.playerContexts[playerId]) {
            this.playerContexts[playerId] = new PlayerContext();
        }
        return this.playerContexts[playerId];
    }
}
